export default {
  // Blacklist labels
  usdtBlocked: "# USDT BLOCKED",
  usdcBlocked: "# USDC BLOCKED",

  // Address information
  availableBalance: "Available Balance",
  inOutTransactions: "In & Out Transactions (USDT)",
  inOutCounterparties: "In & Out Counterparties (USDT)",
  cumulativeInOutAmount: "Cumulative In & Out Amount (USDT)",
  avgInOutAmount: "Average In & Out Amount (USDT)",
  creator: "Creator",
  createdAt: "Created At",
  addressNote: "Address Note",
};
